import { LogoAlignment } from '../../services/dataService/PortalData';

export const alignmentToJustifyContent: Record<LogoAlignment, string> = {
  center: 'center',
  left: 'flex-start',
  right: 'flex-end',
};
